import React, { useState } from 'react';
import './CommentsInput.css'; // Assuming you will create a CSS file for styling
import { Globals } from '../../global/Globals';

const TextArea = ({ textAreaInput, placeHolder,className,maxCharacters,value,tabIndex,classNameCharcount }) => {
    const [text, setText] = useState(value || "");
    if(!maxCharacters){
        maxCharacters=Globals.TXT_AREA_MAX_CHARS_LIMIT;
    }
    let extraProps={};
    if(tabIndex){
        extraProps.tabindex=tabIndex;
    }
    const handleChange = (event) => {
        if (event.target.value.length <= maxCharacters) {
            setText(event.target.value);
            textAreaInput(event.target.value);
        }
    };

    return (
        <div className={`text-area-container`} >
            <textarea
                className={"text-area_review "+ className || ""}
                value={text}
                onChange={handleChange}
                maxLength={maxCharacters}
                placeholder={placeHolder}
                {...extraProps}
            />
            <div className={`${classNameCharcount && classNameCharcount} char-counter-review`}>
                {text.length}/{maxCharacters}
            </div>
        </div>
    );
};

export default TextArea;